module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "tp"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_c('strong', [_vm._v("Diana the Huntress")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("The Six Sisters: 5"), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("M.C. Beaton/Marion Chesney")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25975658","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795310959_epub_tp_r1.vue
// module id = 57
// module chunks = 0